// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyBcPj3YhaUiUub80dlofVj690-885q5N0s",
    authDomain: "re-fasbeam.firebaseapp.com",
    projectId: "re-fasbeam",
    storageBucket: "re-fasbeam.firebasestorage.app",
    messagingSenderId: "262993430811",
    appId: "1:262993430811:web:6d67e14e5c0d99f88aabbe",
    measurementId: "G-8HCPF5DS6W"
};

const app = initializeApp(firebaseConfig);

// ✅ Firestore instance
export const db = getFirestore(app);
